module.exports = __webpack_public_path__ + "img/logo-2atm.bd975311.png";